import React, { FC } from "react";
import { Theme, Typography } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Field, FormRenderProps } from "react-final-form";
import BootstrapInput from "../../../components/BootstrapInput";
import Button from "../../../components/Button";
import Loading from "../../../components/Loading";

const useStyles = makeStyles((theme: Theme) => ({
  formControl: {
    "& + &": {
      marginTop: theme.spacing(2),
    },
  },
  title: {
    fontWeight: "bold",
    fontSize: 22,
  },
}));

const MakeCustomPaymentForm: FC<FormRenderProps> = ({
  submitting,
  handleSubmit,
}) => {
  const classes = useStyles();

  return (
    <form noValidate onSubmit={handleSubmit}>
      {submitting && <Loading />}
      <Typography align="center" component="h1" className={classes.title}>
        Make a payment
      </Typography>
      <Typography component="div" className={classes.formControl}>
        <Field
          required
          fullWidth
          type="text"
          label="Amount (USD)"
          placeholder="Amount (USD)"
          name={"amount"}
          component={BootstrapInput}
        />
      </Typography>
      <Typography component="div" className={classes.formControl}>
        <Field
          required
          fullWidth
          type="text"
          label="Comment"
          placeholder="Comment"
          multiline={true}
          rows={5}
          name={"comment"}
          component={BootstrapInput}
        />
      </Typography>
      <Typography
        align="center"
        component="div"
        className={classes.formControl}
      >
        <Button
          type="submit"
          color="secondary"
          variant="contained"
          disabled={submitting}
        >
          Checkout
        </Button>
      </Typography>
    </form>
  );
};

export default MakeCustomPaymentForm;
